import { apiRequest } from "./api";
import type {
  AdultScheduledGigCancellationRequest,
  GigIssueReportRequest,
  LeaveGigRequest,
  RemoveTeenRequest,
  ScheduledGigItemResponse,
  TeenScheduledGigCancellationRequest,
} from "../types/scheduledGigTypes";

export const teenScheduledGigsApi = {
  list(): Promise<ScheduledGigItemResponse[]> {
    return apiRequest<ScheduledGigItemResponse[]>("/api/teen/scheduled-gigs", {
      method: "GET",
    });
  },

  markArrived(requestId: string): Promise<ScheduledGigItemResponse> {
    return apiRequest<ScheduledGigItemResponse>(`/api/teen/scheduled-gigs/${requestId}/arrival`, {
      method: "POST",
    });
  },

  markComplete(requestId: string): Promise<ScheduledGigItemResponse> {
    return apiRequest<ScheduledGigItemResponse>(`/api/teen/scheduled-gigs/${requestId}/complete`, {
      method: "POST",
    });
  },

  reportIssue(requestId: string, payload: GigIssueReportRequest): Promise<ScheduledGigItemResponse> {
    return apiRequest<ScheduledGigItemResponse>(`/api/teen/scheduled-gigs/${requestId}/issue`, {
      method: "POST",
      body: payload,
    });
  },

  cancel(requestId: string, payload?: TeenScheduledGigCancellationRequest): Promise<ScheduledGigItemResponse> {
    return apiRequest<ScheduledGigItemResponse>(`/api/teen/scheduled-gigs/${requestId}/cancel`, {
      method: "POST",
      body: payload,
    });
  },

  leave(requestId: string, payload: LeaveGigRequest): Promise<ScheduledGigItemResponse> {
    return apiRequest<ScheduledGigItemResponse>(`/api/teen/scheduled-gigs/${requestId}/leave`, {
      method: "POST",
      body: payload,
    });
  },
};

export const adultScheduledGigsApi = {
  list(): Promise<ScheduledGigItemResponse[]> {
    return apiRequest<ScheduledGigItemResponse[]>("/api/adult/scheduled-gigs", {
      method: "GET",
    });
  },

  markComplete(requestId: string): Promise<ScheduledGigItemResponse> {
    return apiRequest<ScheduledGigItemResponse>(`/api/adult/scheduled-gigs/${requestId}/complete`, {
      method: "POST",
    });
  },

  reportIssue(requestId: string, payload: GigIssueReportRequest): Promise<ScheduledGigItemResponse> {
    return apiRequest<ScheduledGigItemResponse>(`/api/adult/scheduled-gigs/${requestId}/issue`, {
      method: "POST",
      body: payload,
    });
  },

  cancel(requestId: string, payload?: AdultScheduledGigCancellationRequest): Promise<ScheduledGigItemResponse> {
    return apiRequest<ScheduledGigItemResponse>(`/api/adult/scheduled-gigs/${requestId}/cancel`, {
      method: "POST",
      body: payload,
    });
  },

  removeTeen(requestId: string, payload: RemoveTeenRequest): Promise<ScheduledGigItemResponse> {
    return apiRequest<ScheduledGigItemResponse>(`/api/adult/scheduled-gigs/${requestId}/remove-teen`, {
      method: "POST",
      body: payload,
    });
  },
};
